module.exports = __webpack_public_path__ + "img/TV_clean_box05.316835d5.jpg";